@if (filters().length > 0) {
  <motif-chip-group class="chips-group">
    <div class="chip-container">
      <strong> {{ 'commonGrid.filter.chips-title' | translate }} - </strong>
    </div>
    @for (filterChip of filterChips | keyvalue: chipsCompare; track filterChip.key) {
      <div class="chip-container chip-container_{{ location() }}">
        {{ filterChip.key }}:
        @for (chipValue of filterChip.value; track chipValue) {
          <motif-chip
            class="filter-chip"
            type="outlined"
            variant="warning"
            [removeable]="true"
            (remove)="onRemoveChip(filterChip, chipValue)">
            <span class="left-aligned-text">{{ chipValue }}</span>
          </motif-chip>
        }
      </div>
    }

    @if (showClearAll()) {
      <div class="chip-container chip-container_{{ location() }}">
        <button class="filter-chip" motifButton color="link-alt" size="small" (click)="onRemoveAll()">
          {{ 'commonGrid.filter.clear' | translate }}
        </button>
      </div>
    }
  </motif-chip-group>
}
